import { v4 as uuidv4 } from "uuid";
import { getMarginOptions } from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getBorderColorOptions,
  getBorderStyleOptions,
  getBorderWidthOptions,
} from "@/react/components/shared/BuilderUI/utils/dividerStyleHelpers";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "line",
  props: {
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        borderColor: getBorderColorOptions({
          defaultValue: defaultStyles.borderColor,
        }),
        borderWidth: getBorderWidthOptions({
          defaultValue: defaultStyles.borderWidth,
        }),
        borderStyle: getBorderStyleOptions({
          defaultValue: defaultStyles.borderStyle,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
        sizing: getSizingOptions({
          defaultValue: defaultStyles.sizing,
        }),
      },
    },
  },
};
